import React from 'react';
import { get, merge, isEmpty, noop, forEach, isEqual, find /*findIndex*/ } from 'lodash';
import searchQuery from 'query-string';
import { withRouter } from 'react-router-dom';

// local dependencies
import { memberDetailsOrdersEntityWidget as MemberDetailsOrdersEntityWidgetView } from 'ui/views/widgets/memberDetailsOrdersEntityWidget';
import { MemberDetailsOrdersEntityWidgetService } from 'services/memberDetailsOrdersEntityWidget';
import { SERVICE_RESPONSE_STATUS, SIZES, ORIGIN, ERROR_RESPONSE_TEMPLATE, CANCELLED_ORDER_STATUS } from 'constants/common';
import * as pageLevelPreloader from 'modules/page-level-preloader';
import * as errorOverlay from 'utils/errorOverlay';
import {trackingDetailsOverlayView as TrackingDetailsOverlayView } from 'ui/views/widgets/trackingDetailsOverlay';

// import * as notificationOverlay from 'utils/notificationOverlay';
import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';
import * as confirmOverlay from 'utils/confirmOverlay';
import { getLabel } from 'utils/getLabel';
import { overlay } from 'modules/overlay';
import { OVERLAY_VIEWS } from 'constants/templates';
import * as backRoute from 'utils/backRoute';

// import * as successOverlay from 'utils/successOverlay';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberDetailsOrdersEntityWidget } from 'ui/containers/MemberDetailsOrdersEntityWidget';
 *
 * // render
 * <MemberDetailsOrdersEntityWidget propName='propValue'/>
 */
class _MemberDetailsOrdersEntityWidget extends React.Component {
    
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // bind methods
        this.handleActionClick = this.handleActionClick.bind( this );

        // component state
        this.state = {
            isFetching: true,
            displayTrackingDialog: false,
            parcelShieldResponseData:{},
            networkStatus: undefined,
            componentData: undefined
        };
       
        // Member Detail instance
        this.memberDetailsOrdersEntityWidgetService = new MemberDetailsOrdersEntityWidgetService();

        // start member detail data fetch
        this.memberDetailsOrdersEntityWidgetData();
    }


    /**
     * @desc: fetch initial componnet data
     */
    async memberDetailsOrdersEntityWidgetData() {
        log.debug( 'MemberDetailsOrdersEntityWidget.memberDetailsOrdersEntityWidgetData()' );

        // cancel ongoing request
        this.memberDetailsOrdersEntityWidgetService.cancel();

        try {
            const { status, data }  = await this.memberDetailsOrdersEntityWidgetService.fetchData( {
                url: this.props.widget.url,
                data: this.props.requestPayload,
            } );

            // check if response status was success
            if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
                } );
            } else {

                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                    componentData: data,
                } );
            }

        } catch( e ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
            } );
        }
    }

    /**
     * @desc: refresh that particular order
     */
    // async refreshOrderDetail( { url, memberId, orderId } ) {
    //     log.debug( 'MemberDetailsOrdersEntityWidget.refreshOrderDetail()' );

    //     // cancel ongoing request
    //     this.memberDetailsOrdersEntityWidgetService.cancel();

    //     try {
    //         const { status, data }  = await this.memberDetailsOrdersEntityWidgetService.refreshOrder( {
    //             url: url,
    //             data: {
    //                 'context': {
    //                   'memberId': memberId
    //                 },
    //                 'data': {
    //                   'orderId': orderId
    //                 }
    //             }
    //         } );

    //         // check if response status was success
    //         if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
    //             errorOverlay.open();
    //         } else {

    //             const _data = cloneDeep( this.state.componentData );

    //             forEach( _data.data.state.items, item => {
    //                 if( head( data ).id === item.id ) {
    //                     item.values = head( data ).values;
    //                     item.fetching = false;
    //                 }
    //             } );

    //             this.setState( {
    //                 isFetching: false,
    //                 networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
    //                 componentData: _data,
    //             } );
    //         }

    //     } catch( e ) {
    //         this.setState( {
    //             isFetching: false,
    //             networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
    //         } );
    //     }
    // }

    /**
     * @desc Action handler for column action and group action.
     */
    handleActionClick( { type = 'column', value = {}, item = {}, /*selection = [],*/ parentItem = {} } = {}, callback ) {
        log.debug( 'MemberDetailsOrdersEntityWidget.handleActionClick()'  );

        // get member id and order id
        const memberId = get( this.props, 'requestPayload.context.memberId', null );
        const patientId = get( this.props, 'requestPayload.context.patientId', null );
        const orderId = get( item, 'id', null );
        //const trackingNumber = get(this.props,)

        // prepare back-route state payload
        const backRouteState = backRoute.encode( {
            pathname: this.props.location.pathname,
            payload: {
                entitiesActiveTabIndex: this.props.tabIndex,
                memberId: memberId,
                patientId: patientId
            },
        } );

        // when `orderNumber` is clicked, redirect to order detail page
        if( 'column' === type && 'orderNumber' === value.name ) {
            this.props.history.push( {
                pathname: DASHBOARD_SUB_ROUTES.ORDER_DETAIL,
                state: { ...backRouteState, memberId, patientId },
                search: searchQuery.stringify( {
                    orderId
                } )
            } );
        }

        // when `orderNumber` is clicked, redirect to order detail page
        if( 'column' === type && 'rxNumber' === value.name ) {
            this.props.history.push( {
                pathname: DASHBOARD_SUB_ROUTES.PRESCRIPTION_DETAIL,
                state: { ...backRouteState, memberId, patientId },
                search: searchQuery.stringify( {
                    rxId: get( item, 'id', null )
                } )
            } );
        }

        // cancel order action
        if( 'headAction' === type && 'cancelOrder' === value.name ) {

            if( item.values.captureCancelReasons ) {
                return this.initiateCaptureReasonsCancelOrder( {
                    action: value,
                    payload: {
                        memberId,
                        patientId,
                        orderId,
                    },
                    confirmation: value.confirmation
                }, callback );
            } else{
                return this.initiateCancelOrder( {
                    action: value,
                    payload: {
                        memberId,
                        orderId,
                        patientId
                    },
                    confirmation: value.confirmation
                }, callback );
            }
            
        }

        // edit order action
        if( 'headAction' === type && 'editOrder' === value.name ) {
            return this.initiateEditOrder( {
                url: value.url,
                payload: {
                    memberId,
                    orderId,
                    patientId
                },
            } );
        }

        // reorder action
        if( 'headAction' === type && 'reorder' === value.name ) {
            const canReorder = get( item, 'values.canReorder' );
            const urlMapObject = find( value.urlMap, { 'canReorder': canReorder } );

            if( canReorder ) {
                return this.initiateReOrder( {
                    url: urlMapObject.url,
                    payload: {
                        memberId,
                        orderId,
                        patientId
                    },
                } );
            } else if ( !canReorder ) {
                return this.fetchControlledDrugReOrderInfo( {
                    url: urlMapObject.url,
                    payload: {
                        memberId,
                        orderId,
                        patientId
                    },
                } );
            }
        }

          // fetch notes action
          if( 'headAction' === type && 'orderNotes' === value.name ) {
            return this.initiateFetchNotesHeadAction( {
                url: value.url,
                payload: {
                    orderId,
                    rxId: get( item, 'id', null )
                },
            } );
        }

        // fetch to-dos action
        if( 'headAction' === type && 'orderToDo' === value.name ) {

            const orderData = {};
            orderData.orderId = item.id;
            orderData.rxIds = [];

            forEach( item.values.items, _item => {
                orderData.rxIds = [ ...orderData.rxIds, _item.id ];
            } );

            return this.fetchOrderToDoOptions( {
                url: value.url,
                payload: {
                    context: { memberId, patientId },
                    data: orderData,
                },
            } );
        }

        if( 'column' === type && 'trackingNumber' === value.name ) {
            const currentItemData = this.state.componentData?.data?.state?.items?.find( o => o?.id === orderId);
            const parcelshieldData = currentItemData?.values?.parcelShield || item?.values?.parcelShield;
            return parcelshieldData
                ? this.initiateTrackingNumber( parcelshieldData )
                : currentItemData  
                    ? window.open(currentItemData?.values?.redirectUrl)
                    : window.open(item?.values?.redirectUrl)
        }
        // fetch notes action
        if( 'groupAction' === type && 'notes' === value.name ) {
            return this.initiateFetchNotesAction( {
                url: value.url,
                payload: {
                    orderId: parentItem.id,
                    rxId: get( item, 'id', null )
                },
            } );
        }

        // fetch line to dos action
        if( 'groupAction' === type && 'lineItemToDo' === value.name ) {
            const orderData = {};
            orderData.orderId = parentItem.id;
            orderData.rxIds = get( item, 'id', null );
            return this.fetchOrderToDoOptions( {
                url: value.url,
                payload: {
                    context: { memberId, patientId },
                    data: orderData,
                },
            } );
        }

        // mark resolved action
        if( 'markResolved' === value.name ) {
            return this.initiateMarkResolvedAction( {
                action: value,
                payload: {
                    memberId,
                    orderId: ! isEmpty( item.values.rxNumber ) ? parentItem.id : orderId,
                    patientId
                },
                type,
                rxNumber: item.values.rxNumber
            }, callback );
        }

    }

    /**
     * @desc Action handler for mark resolve action
     */
    async initiateMarkResolvedAction( { action, payload, type, rxNumber }, callback = noop ) {
        log.debug( 'MemberDetailsOrdersEntityWidget.initiateMarkResolvedAction()' );

        const memberId = get( payload, 'memberId', null );
        const patientId = get( payload, 'patientId', null );
        const orderId = get( payload, 'orderId', null );

        overlay.open( {
            settings: {
                modalType: OVERLAY_VIEWS.MARK_RESOLVED,
                showCloseButton: false,
                ignoreOutsideClick: true,
            },
            config: {},
            data: {
                ...action,
                widgetConfig: this.state.componentData.structure.markResolved,
                onSumbitClick: async ( value ) => {
                    
                    overlay.close();

                    // cancel ongoing request
                    this.memberDetailsOrdersEntityWidgetService.cancel();

                    // show page level preloader
                    pageLevelPreloader.show();

                    // fetch component data
                    const { status, resData } = await this.memberDetailsOrdersEntityWidgetService.initiateMarkResolved( {
                        url: action.url,
                        data: {
                            context: {
                                memberId,
                                patientId
                            },
                            data: {
                                orderId,
                                description: value,
                                rxNumber: ( 'groupAction' === type ) ? ( rxNumber ) : ''
                            },
                        },
                    } );

                    // show page level preloader
                    pageLevelPreloader.hide();

                    // check if response status was success
                    if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {

                        this.setState( {
                            isFetching: false,
                            networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                        } );

                        const requestPayloadForRefresh = {
                            'context': {
                              'memberId': memberId,
                              'patientId': patientId
                            },
                            'data': {
                              'orderId': orderId
                            }
                        };

                        callback( { id: orderId, requestPayloadForRefresh: requestPayloadForRefresh } );
                        
                    } else {

                        if ( ! isEmpty( resData.description ) ) {

                                errorOverlay.open( {
                                    message: resData.description,
                                    size: SIZES.SMALL,
                                    template: resData.template
                                } );

                        } else {
                            errorOverlay.open();
                        }
                    }
                },
                onCancelClick: () => {
                    overlay.close();
                },
            },
        } );
    }

    /**
     * @desc Action handler for column action and group action.
     */
    async initiateEditOrder( { url, payload } ) {
        log.debug( 'MemberDetailsOrdersEntityWidget.initiateEditOrder()' );

        // cancel ongoing request
        this.memberDetailsOrdersEntityWidgetService.cancel();

        // show page level preloader
        pageLevelPreloader.show();

        // fetch component data
        const { status } = await this.memberDetailsOrdersEntityWidgetService.editOrder( {
            url: url,
            data: {
                context: {
                    memberId: payload.memberId,
                    patientId: payload.patientId,
                },
                data: {
                    orderId: payload.orderId,
                },
            },
        } );

        // hide page level preloader
        pageLevelPreloader.hide();

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
            }, () => {

                // redirect to edit order checkout page
                this.props.history.push( {
                    pathname: DASHBOARD_SUB_ROUTES.EDIT_ORDER,
                    search: searchQuery.stringify( {
                        orderId: payload.orderId,
                        origin: ORIGIN.MEMBER_MANAMGENT
                    } ),
                    state: {  memberId: payload.memberId, patientId: payload.patientId }
                } );
            } );
        } else {
            errorOverlay.open(); // show error
        }
    }

    /**
     * @desc Action handler for column action and group action.
     */
    async initiateReOrder( { url, payload } ) {
        log.debug( 'MemberDetailsOrdersEntityWidget.initiateReOrder()' );

        // cancel ongoing request
        this.memberDetailsOrdersEntityWidgetService.cancel();

        // show page level preloader
        pageLevelPreloader.show();

        // fetch component data
        const { status } = await this.memberDetailsOrdersEntityWidgetService.reOrder( {
            url: url,
            data: {
                context: {
                    memberId: payload.memberId,
                    patientId: payload.patientId,
                },
                data: {
                    orderId: payload.orderId,
                },
            },
        } );

        // hide page level preloader
        pageLevelPreloader.hide();

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
            }, () => {
                
                // redirect to reorder checkout page
                this.props.history.push( {
                    pathname: DASHBOARD_SUB_ROUTES.RE_ORDER,
                    search: searchQuery.stringify( {
                        orderId: payload.orderId,
                        origin: ORIGIN.MEMBER_MANAMGENT
                    } ),
                    state: { memberId: payload.memberId, patientId: payload.patientId }
                } );
            } );
        } else {
            errorOverlay.open(); // show error
        }
    }

    /**
     * @desc: fetch todo notes
     */
     async fetchControlledDrugReOrderInfo( { url, payload } ) {
        log.debug( 'MemberDetailsOrdersEntityWidget.fetchControlledDrugReOrderInfo()' );

        // cancel ongoing request
        this.memberDetailsOrdersEntityWidgetService.cancel();

        // show page level preloader
        pageLevelPreloader.show();

        // fetch component data
        const { status, data } = await this.memberDetailsOrdersEntityWidgetService.fetchControlledDrugReOrderInfo( {
            url: url,
            data: {
                context: {
                    memberId: get( payload, 'memberId' ),
                    patientId: get( payload, 'patientId' )
                },
                data: {
                    orderId: get( payload, 'orderId' )
                }
            }
        } );

        // hide page level preloader
        pageLevelPreloader.hide();

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {
            
            overlay.open( {
                settings: {
                    modalType: OVERLAY_VIEWS.CONTROLLED_DRUG_REORDER,
                    showCloseButton: false,
                    ignoreOutsideClick: false,
                },
                config: {},
                data: {
                    ...data,

                    // payload: payload,
                    requestPayload: payload,
                    onCancelClick: () => {
                        overlay.close();
                    },
                },
            } );

        } else {
            errorOverlay.open(); // show error
        }
    }

    /**
     * @desc: cancel order
     */
    async initiateCancelOrder( { action, payload, confirmation, /*cancelConfirmation*/ }, callback ) {
        log.debug( 'MemberDetailsOrdersEntityWidget.initiateCancelOrder()' );

        // cancel ongoing request
        this.memberDetailsOrdersEntityWidgetService.cancel();

        const shouldProceed = await confirmOverlay.open( {
            message: getLabel( confirmation ),
            iconName: 'close'
        } );
        
        if( shouldProceed ) {

            // show page level preloader
            pageLevelPreloader.show();

            // fetch component data
            const { status, resData } = await this.memberDetailsOrdersEntityWidgetService.cancelOrder( {
                url: action.url,
                data: {
                    context: {
                        memberId: payload.memberId,
                        patientId: payload.patientId,
                    },
                    data: {
                        orderId: payload.orderId,
                        orderStatus: CANCELLED_ORDER_STATUS,
                    },
                },
            } );

            // hide page level preloader
            pageLevelPreloader.hide();

            // check if response status was success
            if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {

                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                } );

                const requestPayloadForRefresh = {
                    'context': {
                      'memberId': payload.memberId,  
                      'patientId': payload.patientId
                    },
                    'data': {
                      'orderId': payload.orderId
                    }
                };

                callback( { id: payload.orderId, requestPayloadForRefresh: requestPayloadForRefresh } );
                
            } else {

                const template = get( resData, 'template', ERROR_RESPONSE_TEMPLATE.DEFAULT );

                if ( isEqual( template, ERROR_RESPONSE_TEMPLATE.notification ) ) {

                    errorOverlay.open( {
                        message: resData.description,
                        size: SIZES.SMALL,
                        template: resData.template
                    } );

                } else {
                    errorOverlay.open();
                }
            }
        }
    }

    /**
     * @desc: cancel order with reason
     */
    async initiateCaptureReasonsCancelOrder( { action, payload, /*cancelConfirmation*/ }, callback ) {
        log.debug( 'MemberDetailsOrdersEntityWidget.initiateCaptureReasonsCancelOrder()' );


        const memberId = get( payload, 'memberId', null );
        const patientId = get( payload, 'patientId', null );
        const orderId = get( payload, 'orderId', null );

        overlay.open( {
            settings: {
                modalType: OVERLAY_VIEWS.CAPTURE_REASON_CANCEL_ORDER,
                showCloseButton: false,
                ignoreOutsideClick: true,
            },
            config: {},
            data: {
                ...action,
                widgetConfig: this.state.componentData.structure.cancelOrder,
                onSumbitClick: async ( value ) => {
                    
                    overlay.close();

                    // cancel ongoing request
                    this.memberDetailsOrdersEntityWidgetService.cancel();

                    // show page level preloader
                    pageLevelPreloader.show();

                    // fetch component data
                    const { status, resData } = await this.memberDetailsOrdersEntityWidgetService.cancelOrder( {
                        url: action.url,
                        data: {
                            context: {
                                memberId,
                                patientId
                            },
                            data: {
                                orderId,
                                cancelReason: value,
                                orderStatus: CANCELLED_ORDER_STATUS
                            },
                        },
                    } );

                    // show page level preloader
                    pageLevelPreloader.hide();

                    // check if response status was success
                    if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {

                        this.setState( {
                            isFetching: false,
                            networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                        } );

                        const requestPayloadForRefresh = {
                            'context': {
                              'memberId': memberId,
                              'patientId': patientId
                            },
                            'data': {
                              'orderId': orderId
                            }
                        };

                        callback( { id: orderId, requestPayloadForRefresh: requestPayloadForRefresh } );
                        
                    } else {

                        const template = get( resData, 'template', ERROR_RESPONSE_TEMPLATE.DEFAULT );

                        if ( isEqual( template, ERROR_RESPONSE_TEMPLATE.notification ) ) {

                            errorOverlay.open( {
                                message: resData.description,
                                size: SIZES.SMALL,
                                template: resData.template
                            } );

                        } else {
                            errorOverlay.open();
                        }
                    }
                },
                onCancelClick: () => {
                    overlay.close();
                },
            },
        } );
    }

    /**
     * @desc: fetch todo notes
     */
    async fetchOrderToDoOptions( { url, payload } ) {
        log.debug( 'MemberDetailsOrdersEntityWidget.fetchOrderToDoOptions()' );

        // cancel ongoing request
        this.memberDetailsOrdersEntityWidgetService.cancel();

        // show page level preloader
        pageLevelPreloader.show();

        // fetch component data
        const { status, data } = await this.memberDetailsOrdersEntityWidgetService.fetchOrderToDoOptions( {
            url: url,
            data: payload
        } );

        // hide page level preloader
        pageLevelPreloader.hide();

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {
            
            overlay.open( {
                settings: {
                    modalType: OVERLAY_VIEWS.ORDER_TO_DO,
                    showCloseButton: false,
                    ignoreOutsideClick: false,
                },
                config: {},
                data: {
                    ...data,

                    // payload: payload,
                    requestPayload: payload,
                    onCancelClick: () => {
                        overlay.close();
                    },
                },
            } );

        } else {
            errorOverlay.open(); // show error
        }
    }

    async initiateFetchNotesAction( { url, payload } ) {
        log.debug( 'MemberDetailsOrdersEntityWidget.initiateFetchNotesAction()' );

        this.memberDetailsOrdersEntityWidgetService.cancel();

        // show page level preloader
        pageLevelPreloader.show();

        // get status and service data
        const { status, data } = await this.memberDetailsOrdersEntityWidgetService.initNotes( {
            url: url,
            data: { ...this.props.requestPayload, data: payload }
        } );
        const tabData = { data: data, requestPayload: merge( { context: { orderId: payload.orderId }, data: { rxId: payload.rxId } }, this.props.requestPayload ) };

        // show page level preloader
        pageLevelPreloader.hide();

        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {

            overlay.open( {
                settings: {
                    modalType: OVERLAY_VIEWS.CSR_ORDER_LINE_NOTES,
                    showCloseButton: false,
                    ignoreOutsideClick: false,
                },
                config: {},
                data: {
                    ...tabData,
                    requestPayload: { ...this.props.requestPayload, data: payload },
                    onCancelClick: () => {
                        overlay.close();
                    },
                },
            } );
        }  else {
            errorOverlay.open(); // show error
        }
    }

    async initiateTrackingNumber( parcelshieldData ) {
        log.debug( 'MemberDetailsOrdersEntityWidget.initiateTrackingNumber()' );

        this.memberDetailsOrdersEntityWidgetService.cancel();

        // show page level preloader
        pageLevelPreloader.show();
        // show page level preloader
        pageLevelPreloader.hide();
            this.setState( {
                displayTrackingDialog: true,
                parcelShieldResponseData: parcelshieldData
                
            } )
    }

    
    async initiateFetchNotesHeadAction( { url, payload } ) {
        log.debug( 'MemberOrderDetailSummary.initNotes()' );

        // cancel ongoing request
        this.memberDetailsOrdersEntityWidgetService.cancel();

        // show page level preloader
        pageLevelPreloader.show();

        // get status and service data
        const { status, data } = await this.memberDetailsOrdersEntityWidgetService.initOrderNotes( {
            url: url,
            data: merge( { context: { orderId: payload.orderId } }, this.props.requestPayload )
        } );

        // show page level preloader
        pageLevelPreloader.hide();

        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {

            overlay.open( {
                settings: {
                    modalType: OVERLAY_VIEWS.CSR_ORDER_NOTES,
                    showCloseButton: false,
                    ignoreOutsideClick: false,
                },
                config: {},
                data: {
                    data,
                    orderId: payload.orderId,
                    url: url,
                    requestPayload: merge( { context: { orderId: payload.orderId } }, this.props.requestPayload ),
                    onCancelClick: () => {
                        overlay.close();
                    },
                },
            } );
        }  else {
            errorOverlay.open(); // show error
        }
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        this.memberDetailsOrdersEntityWidgetService.cancel(); // cancel ongoing requests
    }


    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <>
            <MemberDetailsOrdersEntityWidgetView
                isFetching={ this.state.isFetching }
                networkStatus={this.state.networkStatus}
                componentData={get(this.state, 'componentData', {})}
                requestPayload={this.props.requestPayload}
                onActionClick={this.handleActionClick}
            />
            {this.state.displayTrackingDialog && 
            <TrackingDetailsOverlayView handleTrackingDialogClose={() => this.setState({
                displayTrackingDialog: false,

            })} data={this.state.parcelShieldResponseData} />
            }
            </>
        );
    }
}

// set display name
_MemberDetailsOrdersEntityWidget.displayName = 'MemberDetailsOrdersEntityWidget';

// set default props
_MemberDetailsOrdersEntityWidget.defaultProps = {};

// prop types
_MemberDetailsOrdersEntityWidget.propTypes = {};

export const MemberDetailsOrdersEntityWidget = withRouter( _MemberDetailsOrdersEntityWidget );
